import { createContext, useState, useContext, useEffect } from "react";

function debounce(fn, ms) {
  let timer;
  return _ => {
    clearTimeout(timer);
    timer = setTimeout(_ => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

const NavbarContext = createContext();

export function NavbarProvider({ children }) {
  const [isOpen, setIsOpen] = useState(true);
  const [dimensions, setDimensions] = useState({ 
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      console.log("Window resized to:", window.innerWidth);
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
      
      if (window.innerWidth < 1000) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    }, 400);

    window.addEventListener('resize', debouncedHandleResize);
    
    // Initial check
    debouncedHandleResize();

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  const toggleNavbar = () => setIsOpen(!isOpen);

  return (
    <NavbarContext.Provider value={{ isOpen, toggleNavbar, dimensions }}>
      {children}
    </NavbarContext.Provider>
  );
}

export function useNavbar() {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error("useNavbar must be used within a NavbarProvider");
  }
  return context;
}
